import React from 'react';
import { Divider, Empty, List, Avatar, Spin, Tag, Input, Card } from 'antd';
import { VideoCameraOutlined, CheckCircleFilled, SearchOutlined } from '@ant-design/icons';
import { YingshiDevice } from './types';

interface YingshiDeviceListProps {
  yingshiDevices: YingshiDevice[];
  selectedYingshiDevice: YingshiDevice | null;
  yingshiLoading: boolean;
  handleSelectYingshiDevice: (device: YingshiDevice) => void;
}

const YingshiDeviceList: React.FC<YingshiDeviceListProps> = ({
  yingshiDevices,
  selectedYingshiDevice,
  yingshiLoading,
  handleSelectYingshiDevice,
}) => {
  const [searchText, setSearchText] = React.useState('');
  
  // Filter devices based on search text
  const filteredDevices = yingshiDevices.filter(device => 
    device.deviceName.toLowerCase().includes(searchText.toLowerCase()) ||
    device.deviceSerial.toLowerCase().includes(searchText.toLowerCase())
  );

  return (
    <div className="yingshi-section">
      <Divider orientation="left" style={{ margin: '12px 0' }}>选择设备</Divider>
      <Spin spinning={yingshiLoading}>
        {yingshiDevices.length > 0 ? (
          <>
            {/* Search input */}
            <Input
              placeholder="搜索设备名称或序列号"
              prefix={<SearchOutlined />}
              value={searchText}
              onChange={e => setSearchText(e.target.value)}
              style={{ marginBottom: 8 }}
              allowClear
            />
            
            {selectedYingshiDevice && (
              <Card 
                size="small" 
                style={{ 
                  marginBottom: 8, 
                  backgroundColor: '#f0f9ff', 
                  borderColor: '#91caff' 
                }}
              >
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <CheckCircleFilled style={{ color: '#1890ff', marginRight: 8 }} />
                  <div>
                    <div style={{ fontWeight: 500 }}>
                      {selectedYingshiDevice.deviceName}
                      <Tag color="blue" style={{ marginLeft: 8 }}>
                        {selectedYingshiDevice.status === 1 ? '在线' : '离线'}
                      </Tag>
                    </div>
                    <div style={{ fontSize: '12px', color: '#666' }}>
                      设备序列号: {selectedYingshiDevice.deviceSerial}
                    </div>
                  </div>
                </div>
              </Card>
            )}
            
            <div className="yingshi-device-list" style={{ maxHeight: '250px', overflowY: 'auto' }}>
              <List
                size="small"
                itemLayout="horizontal"
                dataSource={filteredDevices}
                renderItem={(device) => (
                  <List.Item
                    className={`yingshi-device-item ${selectedYingshiDevice?.deviceSerial === device.deviceSerial ? 'selected' : ''}`}
                    onClick={() => handleSelectYingshiDevice(device)}
                    style={{
                      cursor: 'pointer',
                      padding: '8px',
                      borderRadius: '4px',
                      transition: 'all 0.3s',
                      backgroundColor: selectedYingshiDevice?.deviceSerial === device.deviceSerial ? '#f0f9ff' : 'transparent',
                      border: selectedYingshiDevice?.deviceSerial === device.deviceSerial ? '1px solid #91caff' : '1px solid transparent',
                      marginBottom: '4px'
                    }}
                  >
                    <List.Item.Meta
                      avatar={
                        <Avatar 
                          size="small"
                          icon={<VideoCameraOutlined />} 
                          style={{ 
                            backgroundColor: device.status === 1 ? '#52c41a' : '#f5222d',
                          }}
                        />
                      }
                      title={
                        <div style={{ display: 'flex', alignItems: 'center', fontSize: '14px' }}>
                          {device.deviceName}
                          {selectedYingshiDevice?.deviceSerial === device.deviceSerial && (
                            <CheckCircleFilled style={{ color: '#1890ff', marginLeft: 8 }} />
                          )}
                          <Tag 
                            color={device.status === 1 ? 'success' : 'error'} 
                            style={{ marginLeft: 'auto', fontSize: '12px', padding: '0 4px', lineHeight: '16px', height: '18px' }}
                          >
                            {device.status === 1 ? '在线' : '离线'}
                          </Tag>
                        </div>
                      }
                      description={
                        <div style={{ fontSize: '12px', marginTop: '2px' }}>
                          序列号: {device.deviceSerial}
                        </div>
                      }
                    />
                  </List.Item>
                )}
                locale={{ emptyText: <Empty description="未找到设备" image={Empty.PRESENTED_IMAGE_SIMPLE} /> }}
              />
            </div>
          </>
        ) : (
          <Empty description="未找到设备" />
        )}
      </Spin>
    </div>
  );
};

export default YingshiDeviceList; 